import { Routes, Route } from "react-router";

import { Home } from "./components/Home";
import { I18NProvider } from "./components/i18n";
import { TokenProvider } from "./components/TokenProvider";
import { Login } from "./components/Login";
import { SWRConfig } from "swr";
import { localStorageProvider } from "./swr";
import * as Sentry from "@sentry/react";
import { Rsvp } from "./components/Rsvp";
import { NotificationProvider } from "./components/Notification";

function App() {
  return (
    <Sentry.ErrorBoundary fallback={<p>An error has occurred</p>}>
      <SWRConfig value={{ provider: localStorageProvider }}>
        <I18NProvider>
          <NotificationProvider>
            <TokenProvider>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/story" element={<Home />} />
                <Route path="/tidbits" element={<Home />} />
                <Route path="/schedule" element={<Home />} />
                <Route path="/faq" element={<Home />} />
                <Route path="/registry" element={<Home />} />
                <Route path="/login" element={<Login />} />
                <Route path="/rsvp" element={<Rsvp />} />
              </Routes>
            </TokenProvider>
          </NotificationProvider>
        </I18NProvider>
      </SWRConfig>
    </Sentry.ErrorBoundary>
  );
}

export default App;
